// extracted by mini-css-extract-plugin
export var alternate = "_h-j";
export var black = "_h-6";
export var blue = "_h-f";
export var blueLight = "_h-e";
export var brand = "_h-8";
export var darkMode = "_h-b";
export var error = "_h-a";
export var gray = "_h-5";
export var grayBlue = "_h-d";
export var iconWrapper = "_h-3";
export var inactive = "_h-7";
export var indigo = "_h-g";
export var orange = "_h-i";
export var pink = "_h-h";
export var primary = "_h-0";
export var purple = "_h-9";
export var success = "_h-4";
export var warning = "_h-c";
export var white = "_h-1";
export var whiteSuccess = "_h-2";